<template>
  <div class="box">
    <div class="title">
      <img v-if="icon" :src="icon">
      {{ title }}
    </div>
    <div class="people-box">
      <div v-for="item in list" :key="item.id" class="people">
        <img :src="baseURL+'/'+item.photo">
        <div class="content">
          <div class="top">
            <div class="name">{{ item.name }}</div>
            <div v-if="item.title">{{ item.title }}</div>
          </div>
          <div class="intro">{{ item.intro }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StuBox',
  props: {
    title: String,
    list: Array,
    icon: String
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_BASE_API
    }
  }
}
</script>

<style lang="stylus" scoped>
.box
  margin-top 28px
  .title
    display flex
    align-items center
    margin-bottom 20px
    font-size 22px
    font-weight 600
    color rgba(31, 46, 65, 1)
    margin-left 13px
    img
      margin-right 10px
      width 30px
      height 30px
  .people-box
    display flex
    align-items stretch
    flex-wrap wrap
    .people
      margin-bottom 12px
      background white
      box-shadow 0 2px 4px 0 rgba(231,234,237,0.5)
      border-radius 8px
      font-size 12px
      color rgba(158,159,175,1)
      width 24.25%
      margin-right 1%
      &:nth-child(4n)
        margin-right 0

      img
        width 100%
        display block
        border-radius 8px 8px 0 0
      .content
        padding 17px 12px
        .top
          display flex
          align-items center
          justify-content space-between
          margin-bottom 8px
          .name
            font-weight 600
            color rgba(58,58,58,1)
            font-size 16px
        .intro
          white-space pre-wrap
</style>
